import { render, staticRenderFns } from "./SwitchImage.vue?vue&type=template&id=887579ec&scoped=true&"
import script from "./SwitchImage.vue?vue&type=script&lang=js&"
export * from "./SwitchImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887579ec",
  null
  
)

export default component.exports